/**
 * `/photos/upload` — the standalone bulk uploader of docs/08 §6.3.
 *
 * The same component the profile gallery embeds, given its own route so that
 * "add the shoebox" is a place someone can go, bookmark, and come back to,
 * rather than a mode hidden three clicks inside one person's profile.
 */

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PhotoUploader } from './PhotoUploader.js';
import ui from '../../ui/components.module.css';

export function PhotoUploadPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <h1>{t('photos.uploadTitle')}</h1>
      <PhotoUploader />
      <button type="button" className={ui.buttonSecondary} onClick={() => navigate('/people')}>
        {t('people.backToList')}
      </button>
    </div>
  );
}
